// Hideo - build settings: the values that change with the place the app is deployed to or with its owner, read from
// .env (in git: the values of hideo.app) or .env.local (not in git: overrides on one machine) when Vite builds the app.
// They are all public: they end up in the bundle anyone can read, so no secret ever goes there. Code reads them
// from CONFIG, never from import.meta.env directly.
const env = import.meta.env

/** The site's address without a trailing slash, e.g. https://hideo.app */
const siteUrl = (env.VITE_SITE_URL || 'https://hideo.app').replace(/\/+$/, '')

export const CONFIG = {
  /** OAuth client id of Google Drive (Google Cloud project, docs/deployment.md) */
  googleClientId: env.VITE_GOOGLE_CLIENT_ID || '',
  /** Dropbox app key ('' = Dropbox hidden) */
  dropboxAppKey: env.VITE_DROPBOX_APP_KEY || '',
  siteUrl,
  /** The site's name as shown to the user, e.g. hideo.app */
  siteName: siteUrl.replace(/^https?:\/\//, ''),
  /** Name in the footer and in Settings › Info */
  author: env.VITE_AUTHOR || '',
  /** PayPal link of the donation button ('' = no button; checked by src/features/donate.ts) */
  donateUrl: env.VITE_DONATE_URL || ''
} as const
